const userManagementConstantsAr = {
  userManagement: 'إدارة المستخدمين',
};

export default userManagementConstantsAr;
